<template>
  <van-popup
    v-model="visible"
    :style="{
      width: '75%',
      maxWidth: '270px',
      borderRadius: '18px',
      padding: '20px 16px',
      background: '#ffffff',
    }"
    :overlay="true"
    :close-on-click-overlay="closeOnClickOverlay"
    @click-overlay="handleOverlayClick"
  >
    <div class="notification-popup">
      <!-- 标题 -->
      <div class="popup-title">{{ title }}</div>

      <!-- 内容描述 -->
      <div class="popup-content" v-if="content">
        {{ content }}
      </div>

      <!-- 按钮区域 -->
      <div class="button-area">
        <!-- 确认按钮 -->
        <van-button
          type="primary"
          color="#000000"
          round
          block
          class="confirm-button"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </van-button>

        <!-- 取消按钮（可选） -->
        <van-button
          v-if="showCancelButton"
          type="default"
          round
          block
          style="border: none; background-color: transparent; height: 40px;"
          class="cancel-button"
          @click="handleCancel"
        >
          {{ cancelText }}
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Button } from "vant";

export default {
  name: "NotificationPopup",
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  props: {
    // 是否显示弹窗
    value: {
      type: Boolean,
      default: false,
    },
    // 弹窗标题
    title: {
      type: String,
      required: true,
    },
    // 内容描述
    content: {
      type: String,
      default: "",
    },
    // 确认按钮文字
    confirmText: {
      type: String,
      default: "我知道了",
    },
    // 是否显示取消按钮
    showCancelButton: {
      type: Boolean,
      default: false,
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: "取消",
    },
    // 点击遮罩是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.visible = newVal;
      },
      immediate: true,
    },
    visible(newVal) {
      if (!newVal) {
        this.$emit("input", false);
        this.$emit("close");
      }
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.visible = false;
    },
    // 处理确认按钮点击
    handleConfirm() {
      this.$emit("confirm");
      this.close();
    },
    // 处理取消按钮点击
    handleCancel() {
      this.$emit("cancel");
      this.close();
    },
    // 处理遮罩点击
    handleOverlayClick() {
      if (this.closeOnClickOverlay) {
        this.close();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.notification-popup {
  text-align: center;
}

.popup-title {
  font-size: 17px;
  font-weight: 600;
  color: #1d2129;
  line-height: 24px;
}

.popup-content {
  margin-top: 8px;
  font-size: 15px;
  color: #4E5969;
  line-height: 1.6;
  text-align: center;
  word-break: break-all;
}

.button-area {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.confirm-button {
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  order: 1;
}

.cancel-button {
  font-size: 16px;
  font-weight: 400;
  color: #86909c;
  background-color: #f7f8fa;
  border: 1px solid #e5e6eb;
  order: 2;

  &:active {
    background-color: #f2f3f5;
  }
}
</style>
